import { Loadable } from '../../../Loadable';

export const AsyncAddPartnerLocationGroup = Loadable(() => import('./Add'));
export const AsyncEditPartnerLocationGroup = Loadable(() => import('./Edit'));
export const AsyncPartnerLocationGroupList = Loadable(() => import('./List'));
